// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";

const salesPersonUrl = "/api/v1/salesperson";

export async function getKeyPeople() {
    const keyPeople = await get<any>(`${salesPersonUrl}/getkeypeople`);
    return keyPeople;
}

export async function getCustomerSalesperson(parameter: any) {
    try {
        const result = await get<any>(`${salesPersonUrl}`, parameter);
        return { result, successful: true };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
